<!--  -->
<template>
  <div class="">
    <div class="card">
      <!-- 商品列表 -->
      <div class="typeHeader LR_center">
        <div>
          <el-input
            style="width: 314px"
            :placeholder="addPls('i18n_Product_name_in_Chinese', 'input')"
            v-model="name"
            clearable
            @clear="getgoodsData()"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              type="primary"
              @click="getgoodsData(true)"
              >{{$t('i18n_Search')}}</el-button
            >
          </el-input>
        </div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            plain
            @click="addgoods()"
            >{{$t('i18n_New_Products')}}</el-button
          >
          <el-button
            @click="excelVisible = true"
            type="primary"
            icon="el-icon-download"
            plain
            >{{$t('i18n_Importing_Products')}}</el-button
          >
        </div>
      </div>
      <div class="countTable" style="margin-top: 30px">
        <el-table
          ref="multipleTable"
          border
          :data="goodsLabel"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column :label="$t('i18n_Product_name_in_Chinese')" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.namec }}</template>
          </el-table-column>
          <el-table-column
            prop="namee"
            :label="$t('i18n_product_name_in_English')"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="country" align="center" :label="$t('i18n_Country')">
          </el-table-column>
          <el-table-column prop="goodstype" align="center" :label="$t('i18n_cargo_classification')">
          </el-table-column>
          <el-table-column prop="materialc" align="center" :label="$t('i18n_Material_in_Chinese')">
          </el-table-column>
          <el-table-column prop="purposec" align="center" :label="$t('i18n_Uses')">
          </el-table-column>
          <el-table-column prop="hsCode" align="center" :label="$t('i18n_HTS_code')">
          </el-table-column>
          <el-table-column :label="$t('i18n_electric_or_not')" align="center" width="120">
            <template slot-scope="scope">
              {{ $t(scope.row.isHasBattery ? "i18n_yes" : "i18n_no") }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('i18n_liquid_power_or_not')" align="center" width="120">
            <template slot-scope="scope">
              {{ $t(scope.row.isPowderLiquid ? "i18n_yes" : "i18n_no") }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('i18n_Operation')" align="center" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="goodsEdit(scope.$index, scope.row)"
                >{{$t('i18n_edit')}}</el-button
              >
              <el-button
                size="mini"
                type="text"
                style="color: red"
                @click="delGoodItem(scope.$index, scope.row)"
                >{{$t('i18n_delete')}}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalPage"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 新增编辑商品弹窗 -->
      <el-dialog
        :title="$t('i18n_Create_new_product')"
        :before-close="close"
        :visible.sync="goodstextShow"
        width="850px"
      >
        <div style="width: 100%;margin: 0 20px">
          <span style="color:red">*</span>
          <span >{{$t('i18n_Country_shipment_type')}}</span>
          <el-cascader style="margin-left:10px"
           size="small"
            v-model="countryId"
            :options="countryList"
            @change="MyhandleChange"
          >
          </el-cascader>
        </div>

        <div style="width: 100%; margin: 20px 0">
          <el-form
            size="small"
            ref="addgoodform"
            :model="addgoodform"
            label-width="110px"
            class="LR_center"
          >
            <div style="width: 45%">
              <el-form-item
                style="width: 100%"
                :label="$t('i18n_Product_name_in_Chinese')"
                :rules="{
                  required: true,
                  message: '中文品名不能为空',
                  trigger: 'blur',
                }"
              >
                <el-input
                  :placeholder="$t('i18n_please_enter')"
                  v-model="addgoodform.namec"
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100%" :label="$t('i18n_brands')">
                <el-input
                  :placeholder="$t('i18n_please_enter')"
                  v-model="addgoodform.brand"
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100%" :label="$t('i18n_HTS_code')">
                <el-input
                  :placeholder="$t('i18n_please_enter')"
                  v-model="addgoodform.hsCode"
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100%" :label="$t('i18n_Material_in_Chinese')">
                <el-input
                  :placeholder="$t('i18n_please_enter')"
                  v-model="addgoodform.materialc"
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100%" :label="$t('i18n_Product_uses_in_Chinese')">
                <el-input
                  style="width: 100%"
                  :placeholder="$t('i18n_please_enter')"
                  v-model="addgoodform.purposec"
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100%"  :rules="{
                  required: true,
                  message: '是否液体/粉末',
                  trigger: 'change',
                }"
              :label="$t('i18n_electric_or_not')">
                <el-select
                  style="width: 100%"
                  v-model="addgoodform.isHasBattery"
                  :placeholder="$t('i18n_please_choose')"
                >
                  <el-option :label="$t('i18n_yes')" :value="true"> </el-option>
                  <el-option :label="$t('i18n_no')" :value="false"> </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="width: 45%">
              <el-form-item
                style="width: 100%"
                :label="$t('i18n_product_name_in_English')"
                :rules="{
                  required: true,
                  message: '英文品名不能为空',
                  trigger: 'blur',
                }"
              >
                <el-input
                  style="width: 100%"
                  :placeholder="$t('i18n_please_enter')"
                  v-model="addgoodform.namee"
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100%" label="SKU">
                <el-input
                  :placeholder="$t('i18n_please_enter')"
                  v-model="addgoodform.sku"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('i18n_product_value')"
              >
                <el-input
                  style="width: 275px"
                  :placeholder="$t('i18n_please_enter')"
                  type="number"
                  v-model.number="addgoodform.declaredValue"
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100%" :label="$t('i18n_material_in_English')">
                <el-input
                  :placeholder="$t('i18n_please_enter')"
                  v-model="addgoodform.materiale"
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 100%" :label="$t('i18n_Product_uses_in_English')">
                <el-input
                  :placeholder="$t('i18n_please_enter')"
                  v-model="addgoodform.purposee"
                ></el-input>
              </el-form-item>

              <el-form-item  :rules="{
                  required: true,
                  message: '是否液体/粉末',
                  trigger: 'change',
                }"
              style="width: 100%" :label="$t('i18n_liquid_power_or_not')">
                <el-select
                  style="width: 100%"
                  v-model="addgoodform.isPowderLiquid"
                  :placeholder="$t('i18n_please_choose')"
                >
                  <el-option :label="$t('i18n_yes')" :value="true"> </el-option>
                  <el-option :label="$t('i18n_no')" :value="false"> </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form>
          <div
            style="width: 100%; padding: 30px; box-sizing: border-box"
            class="TB_center"
          >
            <el-button type="primary" @click="addgoodtext('addgoodform')">{{
              GoodsCategory ? $t("i18n_confirm_addition") : $t("i18n_confirm_revision")
            }}</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 新增编辑商品弹窗END -->

      <!-- Excel上传 -->
      <el-dialog
        title="文件上传"
        :visible.sync="excelVisible"
        width="70%"
        center
      >
        <!--  :show-file-list="false" 是否显示上传文件的list -->
        <!-- drag  是否可拖拽 -->
        <!--  multiple 是否上传多文件 -->
        <!--   :action="upUrl" 上传地址 -->
        <el-upload
          style="text-align: center"
          :show-file-list="false"
          :on-error="handleError"
          :on-success="handleSuccess"
          :before-upload="handleBeforeUpload"
          class="upload-demo"
          drag
          :http-request="uploadSectionFile"
          action=""
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{$t('i18n_Drag_file_here_or')}}<em>{{$t('i18n_click_Upload')}}</em></div>
          <div class="el-upload__tip" slot="tip">{{$t('i18n_xls_and_xlsx_only')}}</div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button
            style="margin-right: 20px"
            size="mini"
            @click="cancel()"
            >{{$t('i18n_cancel')}}</el-button
          >

          <el-button size="mini" @click="donwLoadTemplate" type="success"
            >{{$t('i18n_Download_Template')}}</el-button
          >
        </span>

        <el-table
          style="margin-top: 20px; width: 100%"
          v-if="resultList.length"
          :data="resultList"
          border
        >
          <el-table-column prop="lineNumber" :label="$t('i18n_Number_of_rows')" width="180">
          </el-table-column>
          <el-table-column prop="isSuccess" :label="$t('i18n_Is_it_successful')" width="180">
            <template slot-scope="scope">
              {{ $t(scope.row.isSuccess ? "i18n_Success" : "i18n_Failure") }}
            </template>
          </el-table-column>
          <el-table-column prop="failureReason" :label="$t('i18n_Description')"> </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { addPls } from '@/utils/placeholderI18n'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      // 上传成功后返回的list
      resultList: [],
      // 搜索
      name: "",
      countryProp: { label: "name", value: "id", children: "children" },
      totalPage: 0,
      currentPage: 1,
      pageSize: 10,
      countryList: [],
      countryId: [],
      goodstypelist: [],
      goodsTypeId: "",
      excelVisible: false,
      Sgodname: "",
      goodsLabel: [],
      addgoodform: {
        id: "",
        brand: "",
        customerid: 0,
        declaredValue: 0,
        goodstypeid: 0,
        hsCode: "",
        id: 0,
        isHasBattery: false,
        isPowderLiquid: false,
        materialc: "",
        materiale: "",
        namec: "",
        namee: "",
        purposec: "",
        purposee: "",
        sku: "",
      },
      goodstextShow: false,
      goodsTypeShow: false,
      GoodsCategory: true, //true是新增 false是修改
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    cancel(){
      this.excelVisible = false
      this.resultList = []
    },
    changeGStype(id, index) {
      //切换货物类型
    },
    handleSizeChange(val) {
      console.log(val);
      // 只要换页数就直接返回1页
      this.pageSize = val;
      this.getgoodsData();
    },
    handleCurrentChange(val) {
      console.log(val);
      this.currentPage = val;
      this.getgoodsData();
    },
    getInner(arr) {
      if (arr == null) {
        return null;
      }
      return arr.map((item) => {
        return {
          label: item.name,
          value: item.id,
          children: this.getInner(item.children),
        };
      });
    },
    // todo
    getCountryList() {
      this.axios
        .get(`/fbxData/getCountryGoodsType`)
        .then((res) => {
          if (res.data.code == 200) {
            this.countryList = res.data.datas.map((item) => {
              return {
                label: item.name,
                value: item.id,
                children: this.getInner(item.children),
              };
            });
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 选择仓库后
    MyhandleChange(value, s) {
      // console.log(value,s);
      this.goodsTypeId = value[1];
      this.addgoodform.goodstypeid = value[1];
      this.getGoodstypelist();
    },
    // 上传下载相关 start
    // 自定义上传
    uploadSectionFile(params) {
      // console.log(params);
      let form = new FormData();
      form.append("file", params.file);
      this.axios
        .post(`/fbxData/importFBXCustomerGoods`, form)
        .then((res) => {
          if (res.data.code == 200) {
            console.log(res.data.datas);
            this.resultList = res.data.datas;
          } else {
            this.$message("请选择正确的模板");
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //失败时的方法
    handleError(err) {
      this.$message.info(err.data);
    },
    //成功时的方法
    handleSuccess(response) {
      //  console.log(response);
      if (response.isSuccess) {
        this.$message.success(response.error);
        this.getListByParam();
        return;
      }
      this.$message.info(response.error);
    },
    //上传之前校验的方法
    handleBeforeUpload(file) {
      // 校验
      let legalName = ["xlsx", "xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        console.log(legalName.includes(name));
      } else {
        this.$message.info(this.$t("i18n_xls_and_xlsx_only"));
        return false;
      }
    },
    donwLoadTemplate() {
      this.axios
        .get(
          `/fbxData/getFBXCustomerGoodsTemplate`,

          {
            responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
          }
        )
        .then((res) => {
          let a = document.createElement("a");
          let blob = new Blob([res.data]);
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", "模板.xls");
          a.click();
          // console.log(objectUrl);
          URL.revokeObjectURL(objectUrl); // 释放内存
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 上传下载相关end
    getgoodsData(type) {
      if (type) {
        this.currentPage = 1;
      }
      //获取商品列表
      let params = {
        customerid: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id,
        name: this.name,
        // goodstypeid: 0,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      this.axios
        .post(`/fbxData/pageFbxCustomerGoodsList`, params)
        .then((res) => {
          if (res.data.code == "200") {
            // res.data.datas.forEach((item) => {
            //   this.$set(item, "num", 1);
            // });
            this.goodsLabel = res.data.data.list;
            this.totalPage = res.data.data.total;
          } else {
          }
        })
        .catch((res) => {});
    },
    //-----------
    getGoodstypelist() {
      //商品类型
      //   this.axios
      //     .get(`/filedata/findFBAGoodTypeList?warehouseId=${this.countryId[1]}`)
      //     .then((res) => {
      //       if (res.data.code == "200") {
      //         this.goodstypelist = res.data.datas;
      //       } else {
      //       }
      //     })
      //     .catch((res) => {});
    },
    handleSelectionChange(val) {
      this.thatGoodslist = val;
    },
    goodsEdit(index, item) {
      console.log(item);
      this.countryId = [];
      this.countryId[0] = item.countryId;
      this.countryId[1] = item.goodstypeid;
      this.GoodsCategory = false;
      //   console.log(item.id);
      this.goodstextShow = true;
      this.addgoodform.customerid = JSON.parse(
        sessionStorage.getItem("Authorization")
      ).customerid; //客户id,
      this.addgoodform.brand = item.brand;
      this.addgoodform.declaredValue = item.declaredValue;
      this.addgoodform.goodstypeid = this.countryId[1];
      this.addgoodform.hsCode = item.hsCode;
      this.addgoodform.materialc = item.materialc;
      this.addgoodform.materiale = item.materiale;
      this.addgoodform.namec = item.namec;
      this.addgoodform.namee = item.namee;
      this.addgoodform.purposec = item.purposec;
      this.addgoodform.purposee = item.purposee;
      this.addgoodform.isHasBattery = item.isHasBattery;
      this.addgoodform.isPowderLiquid = item.isPowderLiquid;
      this.addgoodform.sku = item.sku;
      this.addgoodform.id = item.id;
    },
    delGoodItem(index, item) {
      this.$confirm(this.$t("i18n_delete_goods_tip"), this.$t("i18n_hint"), {
        confirmButtonText: this.$t("i18n_confirm"),
        cancelButtonText: this.$t("i18n_cancel"),
        type: "warning",
      })
        .then(() => {
          let params = {
            id: item.id,
          };

          this.axios
            .post(
              `/busFbx/deleteFbxCustomerGoodsCategory`,
              qs.stringify(params)
            )
            .then((res) => {
              if (res.data.code == "200") {
                this.$message({
                  type: "success",
                  message: this.$t("i18n_Success"),
                });

                this.getgoodsData();
              } else {
              }
            })
            .catch((res) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("i18n_Canceled"),
          });
        });
    },

    addgoods() {
      //新增商品信息
      this.goodstextShow = true;
      this.GoodsCategory = true;
      this.addgoodform.id = "";
      Object.keys(this.addgoodform).forEach((key) => {
        this.addgoodform[key] = "";
      });
      this.addgoodform.isHasBattery = false;
      this.addgoodform.isPowderLiquid = false;
      this.countryId = [];
    },
    close() {
      this.countryId = ["", ""];
      this.goodstextShow = false;
    },
    addgoodtext(formName) {
      // 校验是否选了类型
      if(this.countryId.length == 0){
        return this.$message.info(this.addPls('i18n_product_type', 'select'))
      }
      if (this.addgoodform.namec == "") return this.$message(this.addPls("i18n_Product_name_in_Chinese", 'input'));
      if (this.addgoodform.namee == "") return this.$message(this.addPls("i18n_product_name_in_English", 'input'));
      // if (this.addgoodform.declaredValue == "")
      //   return this.$message("请输入货值");
      if (this.addgoodform.declaredValue && this.addgoodform.declaredValue <= 0)
        return this.$message(this.$t("i18n_product_value_bigger_0"));
      let params = {
        customerid: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id,
        brand: this.addgoodform.brand,
        declaredValue: this.addgoodform.declaredValue,
        goodstypeid: this.addgoodform.goodstypeid,
        hsCode: this.addgoodform.hsCode,
        materialc: this.addgoodform.materialc,
        materiale: this.addgoodform.materiale,
        namec: this.addgoodform.namec,
        namee: this.addgoodform.namee,
        purposec: this.addgoodform.purposec,
        purposee: this.addgoodform.purposee,
        sku: this.addgoodform.sku,
        id: this.addgoodform.id,
        isHasBattery: this.addgoodform.isHasBattery,
        isPowderLiquid: this.addgoodform.isPowderLiquid,
      };
      this.axios
        .post(`/busFbx/addOrUpdateFbxCustomerGoodsCategory`, params)
        .then((res) => {
          if (res.data.code == "200") {
            this.goodstextShow = false;
            this.countryId = ["", ""];

            this.getgoodsData();
            this.$message({
              message: "成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.message,
              type: "info",
            });
          }
        })
        .catch((res) => {});
    },
    addPls,
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getgoodsData();
    // this.getGoodstypelist();
    this.getCountryList();
    // this.getPopList();
  },
};
</script>
<style  scoped>
.el-table >>> th.gutter {
  display: table-cell !important;
}
.card {
  padding: 30px;
}

.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/FBAheader/FbaGoodsBase.vue